/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const metaAdSetDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	budget: z.number(),
	ads: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			status: z.string(),
			metaAdSetId: z.string(),
			updatedAt: z.iso.datetime(),
		}),
	),
	updatedAt: z.iso.datetime(),
})

export type MetaAdSetDataSchema = z.infer<typeof metaAdSetDataSchema>
